export class ConveyancePropertyInfoResultDto {
    propertyAddress: string;
    city: string;
    state: string;
    zip: string;
    unit: string;
}
